function PageLoader() {
    return (
        <div className="flex h-screen w-full items-center justify-center text-[100px]">
            <img src="/brand/link-p-logo-lg.png" alt="brand" />
        </div>
    );
}

export default PageLoader;
